<template>
    <div>
        <div class="bill-container">
            <div class="manage-main">
                <div class="rule" style="display: flex;background: #fff;">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">账单管理</div>
                        <div class="manage-order">
                            <div class="input-box">
                                <span>订单号</span>
                                <!--<div class="select-box">-->
                                <!--<select>-->
                                <!--<option value="1"></option>-->
                                <!--</select>-->
                                <!--</div>-->
                                <input type="text" v-model="OrderNO" maxlength="20">
                                <i v-if="OrderNO!=''" class="iconfont icon-guanbi" @click="OrderNO=''"></i>
                            </div>
                            <div class="input-box">
                                <span>预定酒店名</span>
                                <input type="text" v-model="HotelName" maxlength="50">
                                <i v-if="HotelName!=''" class="iconfont icon-guanbi" @click="HotelName=''"></i>
                            </div>
                            <div class="input-box">
                                <span>是否结算</span>
                                <div class="select-box">
                                    <select v-model="IsCleared">
                                        <option value="">不限</option>
                                        <option value="true">是</option>
                                        <option value="false">否</option>
                                    </select>
                                </div>
                            </div>
                            <div class="btn-box">
                                <div class="btn manage-search" @click="Page = 1;
initData()">查询</div>
                            </div>
                        </div>

                        <div class="search-result">
                            <p>搜索到<span>{{total}}</span>条符合条件的账单</p>
                            <table class="baobiao-table" style="width: 100%">
                                <thead>
                                <tr>
                                    <td style="width:55px;">编号</td>
                                    <td style="width:260px;">账单名称</td>
                                    <td style="width:51px;">币种</td>
                                    <td style="width:140px;">应收金额<br>已收金额</td>
                                    <td style="width:102px;">生成时间</td>
                                    <td style="width:94px;">结算类型</td>
                                    <td style="width:108px;">是否结清</td>
                                    <td style="width:120px;">操作</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                <tr v-for="(item, index) in BillList">
                                    <td>{{item.BillID}}</td>
                                    <td>{{item.NO}}</td>
                                    <td>{{item.Currency}}</td>
                                    <td><span class="price">{{item.Receivable.toFixed(2)}}</span>{{item.Received.toFixed(2)}}
                                    </td>
                                    <td>{{item.BuildStartDate|dateToYMDline}}<br>{{item.BuildEndDate|dateToYMDline}}
                                    </td>
                                    <td>{{item.SettlementTypeName}}</td>
                                    <td>{{item.IsSettled?'已结清':'未结清'}}</td>
                                    <td>
                                        <div class="detail" @click="routerToDetails(item.BillID)">详情</div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="table-loading" v-if="isLoading">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div class="table-no-more" v-if="!isLoading&&total ==0">
                                暂无数据...
                            </div>
                        </div>
                        <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页

    export default {
        name: "billList",
        components: {
            Loading,
            Menu,
            Paginate
        },
        data: function () {
            return {
                isLoading: false,
                OrderNO: '',
                HotelName: '',
                IsCleared: '',
                Page: 1,
                PageSize: 10,
                BillList: [],
                total: 0
            }
        },
        mounted() {
            this.initData();
            document.title='账单管理---云境';
        },
        methods: {
            pageSelect(val){
                this.total=0;
                this.BillList=[];
                this.Page=val;
                this.initData();
            },
            routerToDetails(id){
                const {href} = this.$router.resolve({
                    name: 'BillDetails',
                    params: {
                        id:id
                    }
                })
                window.open(href, '_blank')
            },
            initData() {
                var that = this;
                that.isLoading = true
                var params = {
                    OrderNO: that.OrderNO,
                    HotelName: that.HotelName,
                    IsCleared: that.IsCleared,
                    Page: that.Page,
                    PageSize: that.PageSize
                }
                that.postRequest({
                    url: that.Api.getBill,
                    params: params
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.BillList = res.Result;
                        that.total = res.Total
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bill/List.vue